/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
import {
	ASK_ROVO_MENU_ITEM,
	ASSETS_MENU_ITEM,
	BLOCK_TEMPLATES_SECTION,
	CUSTOM_PANEL_MENU_ITEM,
	DATE_MENU_ITEM,
	DATA_AND_CHARTS_SECTION,
	EMOJI_MENU_ITEM,
	EMBED_SECTION,
	ERROR_PANEL_MENU_ITEM,
	HYPERLINK_MENU_ITEM,
	INFO_PANEL_MENU_ITEM,
	JIRA_WORK_ITEMS_MENU_ITEM,
	LOOM_MENU_ITEM,
	MEDIA_INSERT_MENU_ITEM,
	MEDIA_SECTION,
	NOTE_PANEL_MENU_ITEM,
	ORDERED_LIST_MENU_ITEM,
	OTHER_SECTION,
	RECOMMENDED_SECTION,
	ROVO_SECTION,
	STATUS_MENU_ITEM,
	STRUCTURE_SECTION,
	SUCCESS_PANEL_MENU_ITEM,
	TABLE_MENU_ITEM,
	TEXT_FORMATTING_SECTION,
	UNORDERED_LIST_MENU_ITEM,
	WARNING_PANEL_MENU_ITEM,
} from './keys';

export const QUICK_INSERT_MENU_RANK: {
	readonly 'quick-insert-block-templates-section': 7;
	readonly 'quick-insert-data-and-charts-section': 6;
	readonly 'quick-insert-embed-section': 3;
	readonly 'quick-insert-media-section': 2;
	readonly 'quick-insert-other-section': 8;
	readonly 'quick-insert-recommended-section': 0;
	readonly 'quick-insert-rovo-section': 5;
	readonly 'quick-insert-structure-section': 1;
	readonly 'quick-insert-text-formatting-section': 4;
} = {
	[RECOMMENDED_SECTION.key]: 0,
	[STRUCTURE_SECTION.key]: 1,
	[MEDIA_SECTION.key]: 2,
	[EMBED_SECTION.key]: 3,
	[TEXT_FORMATTING_SECTION.key]: 4,
	[ROVO_SECTION.key]: 5,
	[DATA_AND_CHARTS_SECTION.key]: 6,
	[BLOCK_TEMPLATES_SECTION.key]: 7,
	[OTHER_SECTION.key]: 8,
} as const;

export const STRUCTURE_SECTION_RANK: {
	readonly 'quick-insert-custom-panel-menu-item': 1400;
	readonly 'quick-insert-date-menu-item': 400;
	readonly 'quick-insert-error-panel-menu-item': 1300;
	readonly 'quick-insert-info-panel-menu-item': 900;
	readonly 'quick-insert-note-panel-menu-item': 1000;
	readonly 'quick-insert-status-menu-item': 300;
	readonly 'quick-insert-success-panel-menu-item': 1100;
	readonly 'quick-insert-table-menu-item': 200;
	readonly 'quick-insert-warning-panel-menu-item': 1200;
} = {
	[TABLE_MENU_ITEM.key]: 200,
	[STATUS_MENU_ITEM.key]: 300,
	[DATE_MENU_ITEM.key]: 400,
	[INFO_PANEL_MENU_ITEM.key]: 900,
	[NOTE_PANEL_MENU_ITEM.key]: 1000,
	[SUCCESS_PANEL_MENU_ITEM.key]: 1100,
	[WARNING_PANEL_MENU_ITEM.key]: 1200,
	[ERROR_PANEL_MENU_ITEM.key]: 1300,
	[CUSTOM_PANEL_MENU_ITEM.key]: 1400,
} as const;

export const MEDIA_SECTION_RANK: {
	readonly 'quick-insert-emoji-menu-item': 300;
	readonly 'quick-insert-hyperlink-menu-item': 200;
	readonly 'quick-insert-loom-menu-item': 400;
	readonly 'quick-insert-media-insert-menu-item': 100;
} = {
	[MEDIA_INSERT_MENU_ITEM.key]: 100,
	[HYPERLINK_MENU_ITEM.key]: 200,
	[EMOJI_MENU_ITEM.key]: 300,
	[LOOM_MENU_ITEM.key]: 400,
} as const;

export const TEXT_FORMATTING_SECTION_RANK: {
	readonly 'quick-insert-ordered-list-menu-item': 1200;
	readonly 'quick-insert-unordered-list-menu-item': 1100;
} = {
	[UNORDERED_LIST_MENU_ITEM.key]: 1100,
	[ORDERED_LIST_MENU_ITEM.key]: 1200,
} as const;

export const ROVO_SECTION_RANK: {
	readonly 'quick-insert-ask-rovo-menu-item': 100;
} = {
	[ASK_ROVO_MENU_ITEM.key]: 100,
} as const;

export const DATA_AND_CHARTS_SECTION_RANK: {
	readonly 'quick-insert-assets-menu-item': 500;
	readonly 'quick-insert-jira-work-items-menu-item': 300;
} = {
	[JIRA_WORK_ITEMS_MENU_ITEM.key]: 300,
	[ASSETS_MENU_ITEM.key]: 500,
} as const;

export const EXTENSION_ITEM_RANK = 1500;
export const CATEGORY_VIEW_MORE_RANK: number = Number.MAX_SAFE_INTEGER;
